module.exports = __webpack_public_path__ + "img/category-sport-hover.63e018d9.png";